import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { useSearchParams } from "react-router-dom";
import { parseISO, format } from "date-fns";
import { buttonVariants } from "./ui/button";
import { X } from "lucide-react";
import { cn } from "src/lib/utils";

const CustomDateRange = ({ trigger, ...props }) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const start_date = searchParams.get("start_date");
	const end_date = searchParams.get("end_date");

	const clearDateFilters = () => {
		searchParams.delete("start_date");
		searchParams.delete("end_date");
		setSearchParams(searchParams);
	};

	return (
		<Popover>
			<PopoverTrigger asChild>
				<span
					className={cn(
						buttonVariants({ variant: "ghost" }),
						"tw-border tw-border-[#008080] tw-min-w-[220px] !tw-justify-between tw-px-4 tw-gap-3 tw-bg-white !tw-py-3 tw-font-normal tw-text-sm tw-text-gray-500 tw-focus:tw-border-primary",
					)}
				>
					{start_date ? (
						<span>
							{start_date && format(parseISO(start_date), "PPP")}
							{end_date && " - ".concat(format(parseISO(end_date), "PPP"))}
						</span>
					) : (
						<span>Select date</span>
					)}
					{(start_date || end_date) && (
						<button className="tw-p-1.5" onClick={clearDateFilters}>
							<X className="!tw-size-5 tw-stroke-red-500" />
						</button>
					)}
				</span>
			</PopoverTrigger>
			<PopoverContent className="tw-w-auto tw-p-0" align="start">
				<Calendar
					{...props}
					mode="range"
					selected={{
						from: start_date ? parseISO(start_date) : null,
						to: end_date ? parseISO(end_date) : null,
					}}
					onSelect={(dates) => {
						const { from, to } = dates || {};

						if (from) {
							searchParams.set("start_date", format(from, "yyyy-MM-dd"));
						} else {
							searchParams.delete("start_date");
						}

						if (to) {
							searchParams.set("end_date", format(to, "yyyy-MM-dd"));
						} else {
							searchParams.delete("end_date");
						}

						setSearchParams(searchParams);
					}}
					numberOfMonths={2}
				/>
			</PopoverContent>
		</Popover>
	);
};

export default CustomDateRange;
